export const SYNC_DURATIONS = [
  { label: "10 Mins", total_in_minutes: 10 },
  { label: "15 Mins", total_in_minutes: 15 },
  { label: "20 Mins", total_in_minutes: 20 },
  { label: "30 Mins", total_in_minutes: 30 },
  { label: "60 Mins", total_in_minutes: 60 },
  { label: "2 Hours", total_in_minutes: 120 },
  { label: "3 Hours", total_in_minutes: 180 },
  { label: "4 Hours", total_in_minutes: 240 },
  { label: "6 Hours", total_in_minutes: 360 },
  { label: "12 Hours", total_in_minutes: 720 },
  { label: "24 Hours", total_in_minutes: 1440 },
];
